var _excluded = ["earlyAccessCallbacks"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { AnalyticsMetric } from '@domain-group/fe-allhomes-library';
import gaHelper from '@domain-group/fe-allhomes-library/lib/utils/ga-helper';
import { GAActions, GALabels } from '../analytics/constants';
import { jsx as ___EmotionJSX } from "@emotion/core";
var earlyAccessAnalyticsWrapper = BaseListingDetails => {
  class EarlyAccessAnalyticsWrapper extends React.Component {
    constructor(props) {
      var _this, _props$property$listi;
      super(props);
      _this = this;
      _defineProperty(this, "fireListingMetricNoData", metric => {
        this.fireListingMetric(metric, {});
      });
      _defineProperty(this, "fireListingMetric", (metric, additionalData) => {
        this.context.ahAnalytics.fireListingMetric(this.listingId, metric.metricKey, additionalData);
      });
      _defineProperty(this, "onClickEAContinueSearch", function () {
        gaHelper.interactionEvent(GAActions.EARLY_ACCESS, GALabels.CONTINUE_YOUR_SEARCH);
        if (_this.props.earlyAccessCallbacks.onClickEAContinueSearch) {
          _this.props.earlyAccessCallbacks.onClickEAContinueSearch(...arguments);
        }
      });
      _defineProperty(this, "onClickEAPropertyAlertLink", function () {
        gaHelper.interactionEvent(GAActions.EARLY_ACCESS, GALabels.VIEW_PROPERTY_ALERTS);
        if (_this.props.earlyAccessCallbacks.onClickEAPropertyAlertLink) {
          _this.props.earlyAccessCallbacks.onClickEAPropertyAlertLink(...arguments);
        }
      });
      _defineProperty(this, "onClickEAMap", function () {
        gaHelper.interactionEvent(GAActions.EARLY_ACCESS, GALabels.INTERACT_WITH_MAP);
        if (_this.props.earlyAccessCallbacks.onClickEAMap) {
          _this.props.earlyAccessCallbacks.onClickEAMap(...arguments);
        }
      });
      _defineProperty(this, "onClickEARequestInspection", function () {
        _this.fireListingMetricNoData(AnalyticsMetric.EARLY_ACCESS_REQUEST_INSPECTION);
        gaHelper.conversionEvent(GAActions.EARLY_ACCESS, GALabels.REQUEST_INSPECTION);
        if (_this.props.earlyAccessCallbacks.onClickEARequestInspection) {
          _this.props.earlyAccessCallbacks.onClickEARequestInspection(...arguments);
        }
      });
      _defineProperty(this, "onClickEALearnMore", function () {
        gaHelper.interactionEvent(GAActions.EARLY_ACCESS, GALabels.EARLY_ACCESS_INFO_PAGE);
        if (_this.props.earlyAccessCallbacks.onClickEALearnMore) {
          _this.props.earlyAccessCallbacks.onClickEALearnMore(...arguments);
        }
      });
      _defineProperty(this, "onClickEAExpandMap", function () {
        _this.fireListingMetricNoData(AnalyticsMetric.EARLY_ACCESS_EXPAND_MAP);
        if (_this.props.earlyAccessCallbacks.onClickEAExpandMap) {
          _this.props.earlyAccessCallbacks.onClickEAExpandMap(...arguments);
        }
      });
      this.listingId = props.property ? (_props$property$listi = props.property.listing) === null || _props$property$listi === void 0 ? void 0 : _props$property$listi.id : props.listingId;
    }
    render() {
      var _this$props = this.props,
        earlyAccessCallbacks = _this$props.earlyAccessCallbacks,
        otherBaseListingDetailsProps = _objectWithoutProperties(_this$props, _excluded);
      var props = _objectSpread(_objectSpread({}, otherBaseListingDetailsProps), {}, {
        earlyAccessCallbacks: {
          onClickEAContinueSearch: this.onClickEAContinueSearch,
          onClickEAPropertyAlertLink: this.onClickEAPropertyAlertLink,
          onClickEAMap: this.onClickEAMap,
          onClickEARequestInspection: this.onClickEARequestInspection,
          onClickEALearnMore: this.onClickEALearnMore,
          onClickEAExpandMap: this.onClickEAExpandMap
        }
      });
      return ___EmotionJSX(BaseListingDetails, props);
    }
  }
  EarlyAccessAnalyticsWrapper.propTypes = {
    listingId: PropTypes.number,
    property: PropTypes.shape({
      listing: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        type: PropTypes.string,
        status: PropTypes.string
      })
    }),
    earlyAccessCallbacks: PropTypes.shape({
      onClickEAContinueSearch: PropTypes.func,
      onClickEAPropertyAlertLink: PropTypes.func,
      onClickEAMap: PropTypes.func,
      onClickEARequestInspection: PropTypes.func,
      onClickEALearnMore: PropTypes.func,
      onClickEAExpandMap: PropTypes.func
    })
  };
  EarlyAccessAnalyticsWrapper.defaultProps = {
    listingId: undefined,
    property: undefined,
    earlyAccessCallbacks: {
      onClickEAContinueSearch: () => {},
      onClickEAPropertyAlertLink: () => {},
      onClickEAMap: () => {},
      onClickEARequestInspection: () => {},
      onClickEALearnMore: () => {},
      onClickEAExpandMap: () => {}
    }
  };
  EarlyAccessAnalyticsWrapper.contextTypes = {
    ahAnalytics: PropTypes.shape({
      fireMetric: PropTypes.func,
      fireListingMetric: PropTypes.func
    })
  };
  return EarlyAccessAnalyticsWrapper;
};
export default earlyAccessAnalyticsWrapper;